import './App.css';
import React, { useRef, useEffect, useState } from 'react';
import ReactTinyLink from 'react-tiny-link'
import ChatBot from 'react-simple-chatbot';
import IconButton from './IconButton';
import './IB.css';
import { Table, Row, Col, Divider } from 'antd';
import { getJsonData } from './data'; // 导入函数
import getAjax from './getAjax'
import { v4 as uuidv4 } from 'uuid';

import logo from './imgs/botImg.jpg';

//測試用

//需顯示...
const columns = [
  { title: 'Name', dataIndex: 'name', ellipsis: true }, // 使用 ellipsis 属性
];

//無須顯示...
const columns2 = [
  { title: 'Name', dataIndex: 'name' }, // 使用 ellipsis 属性
];

const rowClassName = (record, index) => {
  return index % 2 === 0 ? 'even-row' : 'odd-row';
};

function App() {

  useEffect(() => {
    document.title = '加賀屋小管家';
  }, []); // 这里的空数组表示仅在组件挂载时运行一次

  const guid = uuidv4();

  function test(num, guid) {

    return null;
  }

  const handleApiCall = async (stepId, steps) => {
    // 模擬 API 呼叫，這裡使用 axios
    // 20230915postgresql關機，先註解
    
        try {
          const response = getAjax({ url: 'https://hlbot.radium.com.tw/BotAPI/api/HLbot', data: { "system": "HL", "user_content": stepId, "user_identify": guid } });
          const data = response.data;
    
          // 根據 API 回應觸發下一個步驟
    
          //if (data.success) {
          //  steps.triggerNextStep();
          //} else {
            // 如果呼叫失敗，可以顯示錯誤訊息或處理其他邏輯
          //  console.error('API call failed');
    
          //steps.triggerNextStep();
        } catch (error) {
          console.error('API call error', error);
        }
  };

  return (
    <div>
      <ChatBot
        botAvatar = {logo} 
        headerTitle="加賀屋小管家"
        hideUserAvatar="true"
        hideSubmitButton="true"
        placeholder=""
        width="100%"
        height="100vh"
        stepDelay={2000}
        botDelay={1000}
        customStyle={{ background: '#383838', color: 'white' }}
        steps={[
          {
            id: '1',
            message: '您好，我是加賀屋小管家，歡迎點選您想要知道的問題！',
            trigger: '2',
            hideInput: true,
          },
          {
            id: '2',
            options: [
              {
                value: 21, label: '查詢房況', trigger: (steps) => {
                  handleApiCall(21, steps.triggerNextStep);
                  return '21';
                }
              },
              {
                value: 22, label: '館內設施介紹', trigger: (steps) => {
                  handleApiCall(22, steps.triggerNextStep);
                  return '22';
                }
              },
              {
                value: 23, label: '餐飲服務', trigger: (steps) => {
                  handleApiCall(23, steps.triggerNextStep);
                  return '23';
                }
              },
              {
                value: 24, label: '宴會廳', trigger: (steps) => {
                  handleApiCall(24, steps.triggerNextStep);
                  return '24';
                }
              },
              {
                value: 25, label: '熱門問題', trigger: (steps) => {
                  handleApiCall(25, steps.triggerNextStep);
                  return '25';
                }
              },
            ],
            hideInput: true,
          },
          {

            id: '21',
            options: [
              {
                value: 211, label: '飯店房型介紹', trigger: (steps) => {
                  handleApiCall(211, steps.triggerNextStep);
                  return '211';
                }
              },
              {
                value: 212, label: '優惠住房專案 [線上訂房]', trigger: (steps) => {
                  handleApiCall(212, steps.triggerNextStep);
                  return '212';
                }
              },
              {
                value: 213, label: '查詢訂房結果', trigger: (steps) => {
                  handleApiCall(213, steps.triggerNextStep);
                  return '213';
                }
              },
              {
                value: 214, label: '回主選單', trigger: (steps) => {
                  handleApiCall(2, steps.triggerNextStep);
                  return '2';
                }
              },
            ],
            hideInput: true,
          },
          {
            id: '211',
            component: (
              <a href="https://www.kagaya.com.tw/rooms/" target='_blank'>
                <Row gutter={[16, 16]}>
                  <Col span={18} style={{ border: 'none' }}>
                    <Table style={{ padding: 0, fontSize: 16, border: 'none !important' }} dataSource={getJsonData('jsonData211')} columns={columns} pagination={false} showHeader={false} rowClassName={rowClassName} />
                  </Col>
                  <Col span={6}>
                    <img src={require("./imgs/room.jpg")} title="踏進大廳的第一秒，幽微的薰香即染上衣角，洗去旅途的奔波；耳邊繚繞的和風音韻，帶來一絲他方的絮語。榻榻米的暖香，為呼吸融入自然氣息；筆直的牆柱削去了直角，是內化於心的溫柔；一扇扇門扉屏蔽的空間，或曲折或寬敞，都是視覺的驚喜。完美的旅行，從北投加賀屋開始。" width="45" height="45" />
                  </Col>
                </Row>
              </a>
            ),
            trigger: '2121',
          },
          {
            id: '212',
            component: (
              <a style={{ color: '#E0FFFF' }} href="https://tlathena.ec-hotel.net/webhotel-v4/0918/index" target='_blank'>
                <Row gutter={[16, 16]}>
                  <Col span={18}>
                    <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData212')} columns={columns} pagination={false} showHeader={false} rowClassName={rowClassName} />
                  </Col>
                  <Col span={6}>
                    <img src={require("./imgs/default.jpg")} title="優惠住房專案 [線上訂房]" width="45" height="45" />
                  </Col>
                </Row>
              </a>
            ),
            trigger: '2121',
            hideInput: true,
          },
          {
            id: '213',
            component: (
              <a style={{ color: '#E0FFFF' }} href="https://tlathena.ec-hotel.net/webhotel-v4/0918/orderSearch" target='_blank'>
                <Row gutter={[16, 16]}>
                  <Col span={18}>
                    <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData213')} columns={columns} pagination={false} showHeader={false} rowClassName={rowClassName} />
                  </Col>
                  <Col span={6}>
                    <img src={require("./imgs/default.jpg")} title="查詢訂房結果" width="45" height="45" />
                  </Col>
                </Row>
              </a>
            ),
            trigger: '2121',
            hideInput: true,
          },
          {
            id: '2121',
            options: [
              {
                value: 2, label: '回主選單', trigger: (steps) => {
                  handleApiCall(2, steps.triggerNextStep);
                  return '2';
                }
              },
              {
                value: 21, label: '其餘房況問題', trigger: (steps) => {
                  handleApiCall(21, steps.triggerNextStep);
                  return '21';
                }
              },              
            ],
            hideInput: true,
          },            
          {
            id: '22',
            options: [
              {
                value: 221, label: '溫泉', trigger: (steps) => {
                  handleApiCall(221, steps.triggerNextStep);
                  return '221';
                }
              },
              {
                value: 222, label: '岩盤浴', trigger: (steps) => {
                  handleApiCall(222, steps.triggerNextStep);
                  return '222';
                }
              },
              {
                value: 223, label: 'SPA', trigger: (steps) => {
                  handleApiCall(223, steps.triggerNextStep);
                  return '223';
                }
              },
              {
                value: 4, label: '回主選單', trigger: (steps) => {
                  handleApiCall(2, steps.triggerNextStep);
                  return '2';
                }
              },
            ],
            hideInput: true,
          },
          {
            id: '221',
            component: (
              <div>
                <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/spring/4f-white-sulfur-public-hot-spring/" target='_blank'>
                  <Row gutter={[16, 16]}>
                    <Col span={18}>
                      <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData221-1')} columns={columns2} pagination={false} showHeader={false} rowClassName={rowClassName} />
                    </Col>
                    <Col span={6}>
                      <img src={require("./imgs/221-1.png")} title="4F 白磺大眾湯 - 北投加賀屋" width="45" height="45" />
                    </Col>
                  </Row>
                </a>
                <Divider dashed />
                <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/spring/5f-private-hot-spring/" target='_blank'>
                  <Row gutter={[16, 16]}>
                    <Col span={18}>
                      <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData221-2')} columns={columns2} pagination={false} showHeader={false} rowClassName={rowClassName} />
                    </Col>
                    <Col span={6}>
                      <img src={require("./imgs/221-2.png")} title="5F 雙人獨立湯屋 - 北投加賀屋" width="45" height="45" />
                    </Col>
                  </Row>
                </a>
              </div>
            ),
            trigger: '2222'
          },
          {
            id: '222',
            component: (
              <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/spring/7f-beitou-stone-and-cypress-sauna/" target='_blank'>
                <Row gutter={[16, 16]}>
                  <Col span={18}>
                    <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData222')} columns={columns2} pagination={false} showHeader={false} rowClassName={rowClassName} />
                  </Col>
                  <Col span={6}>
                    <img src={require("./imgs/222.png")} title="7F 北投石檜木岩盤浴（乾式溫泉）" width="45" height="45" />
                  </Col>
                </Row>
              </a>
            ),
            hideInput: true,
            trigger: '2222'
          },
          {
            id: '223',
            component: (
              <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/spring/related-facilities/" target='_blank'>
                <Row gutter={[16, 16]}>
                  <Col span={18}>
                    <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData223')} columns={columns2} pagination={false} showHeader={false} rowClassName={rowClassName} />
                  </Col>
                  <Col span={6}>
                    <img src={require("./imgs/223.png")} title="The Spa by Socié " width="45" height="45" />
                  </Col>
                </Row>
              </a>
            ),
            hideInput: true,
            trigger: '2222'
          },
          {
            id: '2222',
            options: [
              {
                value: 2, label: '回主選單', trigger: (steps) => {
                  handleApiCall(2, steps.triggerNextStep);
                  return '2';
                }
              },
              {
                value: 22, label: '其餘館內設施介紹', trigger: (steps) => {
                  handleApiCall(22, steps.triggerNextStep);
                  return '22';
                }
              },              
            ],
            hideInput: true,
          },            
          {
            id: '23',
            options: [
              {
                value: 231, label: '天翔廳-日本料理', trigger: (steps) => {
                  handleApiCall(231, steps.triggerNextStep);
                  return '231';
                }
              },
              {
                value: 232, label: '日和廳-咖啡廳', trigger: (steps) => {
                  handleApiCall(232, steps.triggerNextStep);
                  return '232';
                }
              },
              {
                value: 233, label: '夕月酒Bar', trigger: (steps) => {
                  handleApiCall(233, steps.triggerNextStep);
                  return '233';
                }
              },
              {
                value: 4, label: '回主選單', trigger: (steps) => {
                  handleApiCall(2, steps.triggerNextStep);
                  return '2';
                }
              },
            ],
            hideInput: true,
          },
          {
            id: '231',
            component: (
              <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/dining/tenshou-restaurant/" target='_blank'>
                <Row gutter={[16, 16]}>
                  <Col span={18}>
                    <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData231')} columns={columns} pagination={false} showHeader={false} rowClassName={rowClassName} />
                  </Col>
                  <Col span={6}>
                    <img src={require("./imgs/231.jpg")} title="天翔廳- 日本料理" width="45" height="45" />
                  </Col>
                </Row>
              </a>
            ),
            hideInput: true,
            trigger: '2323',
          },
          {
            id: '232',
            component: (
              <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/dining/hiyori-lounge/" target='_blank'>
                <Row gutter={[16, 16]}>
                  <Col span={18}>
                    <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData232')} columns={columns} pagination={false} showHeader={false} rowClassName={rowClassName} />
                  </Col>
                  <Col span={6}>
                    <img src={require("./imgs/232.png")} title="日和廳- 咖啡廳" width="45" height="45" />
                  </Col>
                </Row>
              </a>
            ),
            hideInput: true,
            trigger: '2323',
          },
          {
            id: '233',
            component: (
              <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/dining/yuduki-bar/" target='_blank'>
                <Row gutter={[16, 16]}>
                  <Col span={18}>
                    <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData233')} columns={columns} pagination={false} showHeader={false} rowClassName={rowClassName} />
                  </Col>
                  <Col span={6}>
                    <img src={require("./imgs/233.png")} title="夕月酒Bar" width="45" height="45" />
                  </Col>
                </Row>
              </a>
            ),
            hideInput: true,
            trigger: '2323',
          },
          {
            id: '2323',
            options: [
              {
                value: 2, label: '回主選單', trigger: (steps) => {
                  handleApiCall(2, steps.triggerNextStep);
                  return '2';
                }
              },
              {
                value: 23, label: '其餘餐飲服務問題', trigger: (steps) => {
                  handleApiCall(23, steps.triggerNextStep);
                  return '23';
                }
              },              
            ],
            hideInput: true,
          },            
          {
            id: '24',
            options: [
              {
                value: 241, label: '宴會廳介紹', trigger: (steps) => {
                  handleApiCall(241, steps.triggerNextStep);
                  return '241';
                }
              },
              {
                value: 242, label: '宴會廳線上預約登記', trigger: (steps) => {
                  handleApiCall(242, steps.triggerNextStep);
                  return '242';
                }
              },
              {
                value: 4, label: '回主選單', trigger: (steps) => {
                  handleApiCall(2, steps.triggerNextStep);
                  return '2';
                }
              },
            ],
            hideInput: true,
          },
          {
            id: '241',
            component: (
              <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/banquet-meeting/" target='_blank'>
                <Row gutter={[16, 16]}>
                  <Col span={18}>
                    <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData241')} columns={columns} pagination={false} showHeader={false} rowClassName={rowClassName} />
                  </Col>
                  <Col span={6}>
                    <img src={require("./imgs/default.jpg")} title="宴會廳介紹" width="45" height="45" />
                  </Col>
                </Row>
              </a>
            ),
            hideInput: true,
            trigger: '2424',
          },
          {
            id: '242',
            component: (
              <a style={{ color: '#E0FFFF' }} href="https://www.surveycake.com/s/WL9Pv?utm_source=official&utm_medium=header" target='_blank'>
                <Row gutter={[16, 16]}>
                  <Col span={18}>
                    <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData242')} columns={columns} pagination={false} showHeader={false} rowClassName={rowClassName} />
                  </Col>
                  <Col span={6}>
                    <img src={require("./imgs/default.jpg")} title="宴會廳線上預約登記" width="45" height="45" />
                  </Col>
                </Row>
              </a>
            ),
            hideInput: true,
            trigger: '2424',
          },
          {
            id: '2424',
            options: [
              {
                value: 2, label: '回主選單', trigger: (steps) => {
                  handleApiCall(2, steps.triggerNextStep);
                  return '2';
                }
              },
              {
                value: 24, label: '其餘宴會廳問題', trigger: (steps) => {
                  handleApiCall(24, steps.triggerNextStep);
                  return '24';
                }
              },              
            ],
            hideInput: true,
          },          
          {
            id: '25',
            options: [
              {
                value: 251, label: '預約接駁車', trigger: (steps) => {
                  handleApiCall(251, steps.triggerNextStep);
                  return '251';
                }
              },
              {
                value: 252, label: '餐飲服務時間', trigger: (steps) => {
                  handleApiCall(252, steps.triggerNextStep);
                  return '252';
                }
              },
              {
                value: 253, label: '設施開放時間', trigger: (steps) => {
                  handleApiCall(253, steps.triggerNextStep);
                  return '253';
                }
              },
              {
                value: 254, label: '請問有販售票券嗎?', trigger: (steps) => {
                  handleApiCall(254, steps.triggerNextStep);
                  return '254';
                }
              },
              {
                value: 255, label: '飯店可以帶寵物入住嗎?', trigger: (steps) => {
                  handleApiCall(255, steps.triggerNextStep);
                  return '255';
                }
              },
              {
                value: 256, label: '一日遊專案', trigger: (steps) => {
                  handleApiCall(256, steps.triggerNextStep);
                  return '256';
                }
              },
              {
                value: 257, label: '【抓周宴 / 收涎宴】預約 / 詢問', trigger: (steps) => {
                  handleApiCall(257, steps.triggerNextStep);
                  return '257';
                }
              },
              {
                value: 6, label: '回主選單', trigger: (steps) => {
                  handleApiCall(2, steps.triggerNextStep);
                  return '2';
                }
              },
            ],
            hideInput: true,
          },
          {
            id: '251',
            component: (
              <div style={{ fontSize: 16 }}>
                <span>我們的接駁車採預約後發車，每班上限8位貴賓，如要搭乘，再請提前一日來電跟我們說，先幫您確認是否尚有空位，謝謝您！<br></br><br></br>
                  預約專線:<a style={{ color: 'white' }} href="tel:+886-2-28911238">02-2891-1238</a>(服務時間 每日 09:00-18:00)<br></br><br></br>
                  <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/traffic/" target='_blank'>
                    <Row gutter={[16, 16]}>
                      <Col span={18}>
                        <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData251')} columns={columns} pagination={false} showHeader={false} rowClassName={rowClassName} />
                      </Col>
                      <Col span={6}>
                        <img src={require("./imgs/default.jpg")} title="如何前往日勝生加賀屋？接駁/交通資訊" width="45" height="45" />
                      </Col>
                    </Row>
                  </a>
                </span>
              </div>
            ),
            trigger: '2525'
          },
          {
            id: '252',
            component: (
              <div style={{ fontSize: 16 }}>
                早餐 [自助式]<br></br>
                07:00 ~ 10:00 (最後進場時間 09:00)<br></br><br></br>
                午餐 [日本會席料理]<br></br>
                11:30 ~ 14:00 (最後點餐時間 13:00)<br></br><br></br>
                晚餐 [日本會席料理]<br></br>
                17:30 ~ 21:30 (最後點餐時間 20:00)<br></br><br></br>

                <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/dining/tenshou-restaurant/" target='_blank'>
                  <Row gutter={[16, 16]}>
                    <Col span={18}>
                      <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData231')} columns={columns} pagination={false} showHeader={false} rowClassName={rowClassName} />
                    </Col>
                    <Col span={6}>
                      <img src={require("./imgs/231.jpg")} title="天翔廳- 日本料理" width="45" height="45" />
                    </Col>
                  </Row>
                </a>
              </div>
            ),
            trigger: '2525'
          },
          {
            id: '253',
            component: (
              <div style={{ fontSize: 16 }}>
                <span>
                  4F大眾湯 (每次使用時間4小時為限)<br></br>
                  早上7:00~晚上11:00 (最後進場時間為晚上10:00)<br></br><br></br>
                  <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/spring/4f-white-sulfur-public-hot-spring/" target='_blank'>
                    <Row gutter={[16, 16]}>
                      <Col span={18}>
                        <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData221-1')} columns={columns2} pagination={false} showHeader={false} rowClassName={rowClassName} />
                      </Col>
                      <Col span={6}>
                        <img src={require("./imgs/221-1.png")} title="4F 白磺大眾湯 - 北投加賀屋" width="45" height="45" />
                      </Col>
                    </Row>
                  </a>
                </span>
                <Divider dashed />
                <span>
                  5F雙人獨立湯屋 (每次使用時間90分鐘)<br></br>
                  [週一]~[周五] <br></br>
                  早上9:00-晚上11:30 (最後入場時間：晚上11:30)<br></br><br></br>

                  [週六]~[週日]＆國定假日<br></br>
                  早上9:00-隔日凌晨2:00 (最後入場時間：隔日凌晨2:00)<br></br><br></br>
                  <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/spring/5f-private-hot-spring/" target='_blank'>
                    <Row gutter={[16, 16]}>
                      <Col span={18}>
                        <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData221-2')} columns={columns2} pagination={false} showHeader={false} rowClassName={rowClassName} />
                      </Col>
                      <Col span={6}>
                        <img src={require("./imgs/221-2.png")} title="5F 雙人獨立湯屋 - 北投加賀屋" width="45" height="45" />
                      </Col>
                    </Row>
                  </a>
                </span>
                <Divider dashed />
                <span>
                  7F岩盤浴<br></br>
                  採預約制，預約專線:<a style={{ color: 'white' }}  href="tel:+886-2-28911238">02-2891-1238</a>(服務時間 09:00-18:00)<br></br><br></br>
                  <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/spring/7f-beitou-stone-and-cypress-sauna/" target='_blank'>
                    <Row gutter={[16, 16]}>
                      <Col span={18}>
                        <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData222')} columns={columns2} pagination={false} showHeader={false} rowClassName={rowClassName} />
                      </Col>
                      <Col span={6}>
                        <img src={require("./imgs/222.png")} title="7F 北投石檜木岩盤浴（乾式溫泉）" width="45" height="45" />
                      </Col>
                    </Row>
                  </a>
                </span>
              </div>
            ),
            trigger: '2525'
          },
          {
            id: '254',
            component: (
              <div style={{ fontSize: 16 }}>
                <span>您好，我們目前無對外販售票券，謝謝您。</span>
              </div>
            ),
            trigger: '2525'
          },
          {
            id: '255',
            component: (
              <div style={{ fontSize: 16 }}>
                <span>本飯店除了導盲犬外，無法帶寵物入住。</span>
              </div>
            ),
            trigger: '2525'
          },
          {
            id: '256',
            component: (
              <div style={{ fontSize: 16 }}>
                <a style={{ color: '#E0FFFF' }} href="https://www.kagaya.com.tw/news/%e6%b3%a1%e6%b9%af%e4%b8%80%e6%97%a5%e9%81%8a%e5%84%aa%e6%83%a0%e5%a5%97%e8%a3%9d/" target='_blank'>
                  <Row gutter={[16, 16]}>
                    <Col span={18}>
                      <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData256')} columns={columns2} pagination={false} showHeader={false} rowClassName={rowClassName} />
                    </Col>
                    <Col span={6}>
                      <img src={require("./imgs/256.jpeg")} title="泡湯一日遊優惠套裝" width="45" height="45" />
                    </Col>
                  </Row>
                </a>
                <br></br>
                <span>如要預約，請撥打預約專線: <a style={{ color: 'white' }}  href="tel:+886-2-28911238">02-2891-1238</a> (服務時間 每日 09:00-18:00) 將由服務同仁為您服務，謝謝😊</span>
              </div>
            ),
            trigger: '2525'
          },
          {
            id: '257',
            component: (
              <div style={{ fontSize: 16 }}>
                <span>您好，抓周部分皆由專人負責聯繫介紹～<br></br><br></br>
                  請先填寫線上表單，後續會專人與您聯繫與報價，謝謝！
                  <a style={{ color: '#E0FFFF' }} href="https://www.surveycake.com/s/WL9Pv" target='_blank'>
                    <Row gutter={[16, 16]}>
                      <Col span={18}>
                        <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData257-1')} columns={columns2} pagination={false} showHeader={false} rowClassName={rowClassName} />
                      </Col>
                      <Col span={6}>
                        <img src={require("./imgs/default.jpg")} title="泡湯一日遊優惠套裝" width="45" height="45" />
                      </Col>
                    </Row>
                  </a>
                  <br></br>
                  也歡迎前往官網，查看初步資訊😊<br></br>
                  <a style={{ color: '#E0FFFF' }} href="https://bit.ly/3Ho68OS" target='_blank'>
                    <Row gutter={[16, 16]}>
                      <Col span={18}>
                        <Table style={{ padding: 0 }} dataSource={getJsonData('jsonData257-2')} columns={columns2} pagination={false} showHeader={false} rowClassName={rowClassName} />
                      </Col>
                      <Col span={6}>
                        <img src={require("./imgs/default.jpg")} title="加賀屋官網" width="45" height="45" />
                      </Col>
                    </Row>
                  </a>
                </span>
              </div>
            ),
            trigger: '2525'
          },
          {
            id: '2525',
            options: [
              {
                value: 2, label: '回主選單', trigger: (steps) => {
                  handleApiCall(2, steps.triggerNextStep);
                  return '2';
                }
              },              
              {
                value: 25, label: '其餘熱門問題', trigger: (steps) => {
                  handleApiCall(25, steps.triggerNextStep);
                  return '25';
                }
              },

            ],
            hideInput: true,
          },          
        ]}

        Style={{ fontSize: '24px' }}
      />
    </div>
  );
}

export default App;

/*
  import React from 'react';
  import ChatBot from 'react-simple-chatbot';
  import axios from 'axios';

  function App() {
    const handleApiCall = async (stepId,steps) => {
      // 模擬 API 呼叫，這裡使用 axios
      try {
        const response = await axios.get('https://jsonplaceholder.typicode.com/posts/'+stepId+'/comments');
        const data = response.data;

        // 根據 API 回應觸發下一個步驟
        if (data.success) {
          steps.triggerNextStep();
        } else {
          // 如果呼叫失敗，可以顯示錯誤訊息或處理其他邏輯
          console.error('API call failed');
        }
      } catch (error) {
        console.error('API call error', error);
      }
    };

    return (
      <div className="App">
        <h1>Chatbot with API Call</h1>
        <ChatBot
          steps={[
            {
              id: 'api-call-step',
              message: 'I will now make an API call...',
              trigger: 'api-call',
            },
            {
              id: 'api-call',
              delay: 1000,
              // 使用者點擊以觸發 API 呼叫
              user: true,
              trigger: (steps) => {
                const stepId = 2; // 取得最後一個步驟的 ID
                handleApiCall(stepId, steps.triggerNextStep);
                return 'loading-step';
              },
            },
            {
              id: 'loading-step',
              message: 'Waiting for API response...',
              trigger: 'api-call',
            },
          ]}
        />
      </div>
    );
  }

  export default App;

*/